import { Directive, HostListener } from '@angular/core';

@Directive({ selector: '[bisKeypadNavigation]' })
export class KeypadNavigationDirective {
  numberOfClicks = 0;

  @HostListener('keyup', ['$event'])
  onKeyup(event: KeyboardEvent) {
    // Si on appuie sur la touche entrée du pavé numérique
            // pas le retour chariot qui a meme keycode que entree (13)
            // si on veut retour chariot enlever le test sur NumpadEnter
    // Les valeurs utilisées pour le if proviennent de http://keycode.info/
    // tslint:disable-next-line: deprecation
    if (event.which === 13 && event.key === 'Enter' && event.code === 'NumpadEnter') {
      event.preventDefault();
      this.focusNextElement();
    }
  }

  // PL - tests pour focus l'élément suivant avec la touche Entrée du pavé numérique.
  // Premier jet, inspiré de la solution proposée ici : https://stackoverflow.com/a/35173443
  //
  // Implémentation de la directive tirée de la doc de l'API Angular (https://angular.io/api/core/HostListener#usage-notes),
  // adaptée aux évènements de type "keyboard" grâce à un exemple SO (https://stackoverflow.com/a/37363257)
  //
  // TODO :
  //  - vérifier la robustesse
  focusNextElement() {
    const focussableElements = `
    a:not([disabled]):not(.canNotSelect),
     button:not([disabled]):not([tabindex="-1"]),
      input:not([disabled]):not([readOnly]),
       select:not([disabled]),
        textarea:not([disabled])`;
    // Si jamais un nouvel élément apparait juste en dessous du champ actuel, on ajoute une latence pour le sélectionner
    // une fois qu’il est vraiment là
    setTimeout(() => {
      const focussable = Array.from(document.querySelectorAll(focussableElements));
      const focussableAndVisible = focussable.filter(node => {
        return (<HTMLElement>node).offsetHeight > 0 || (<HTMLElement>node).offsetWidth > 0;
      });
      const index = focussableAndVisible.indexOf(document.activeElement);
      if (index > -1) {
        const nextElement = focussableAndVisible[index + 1] || focussableAndVisible[0];
        (<HTMLElement>nextElement).focus();
      }
    }, 20);
  }
}
